var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateHrIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_967_3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_967_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5C14.9391 5 13.9217 5.42143 13.1716 6.17157C12.4214 6.92172 12 7.93913 12 9C12 10.0609 12.4214 11.0783 13.1716 11.8284C13.9217 12.5786 14.9391 13 16 13C17.0609 13 18.0783 12.5786 18.8284 11.8284C19.5786 11.0783 20 10.0609 20 9C20 7.93913 19.5786 6.92172 18.8284 6.17157C18.0783 5.42143 17.0609 5 16 5ZM16 6.9C16.2758 6.9 16.5489 6.95432 16.8036 7.05985C17.0584 7.16539 17.2899 7.32007 17.4849 7.51508C17.6799 7.71008 17.8346 7.94158 17.9401 8.19636C18.0457 8.45115 18.1 8.72422 18.1 9C18.1 9.27578 18.0457 9.54885 17.9401 9.80364C17.8346 10.0584 17.6799 10.2899 17.4849 10.4849C17.2899 10.6799 17.0584 10.8346 16.8036 10.9401C16.5489 11.0457 16.2758 11.1 16 11.1C15.7242 11.1 15.4511 11.0457 15.1964 10.9401C14.9416 10.8346 14.7101 10.6799 14.5151 10.4849C14.3201 10.2899 14.1654 10.0584 14.0599 9.80364C13.9543 9.54885 13.9 9.27578 13.9 9C13.9 8.44305 14.1212 7.9089 14.5151 7.51508C14.9089 7.12125 15.443 6.9 16 6.9ZM5 8V11H2V13H5V16H7V13H10V11H7V8H5ZM16 14C13.33 14 8 15.33 8 18V21H24V18C24 15.33 18.67 14 16 14ZM16 15.9C18.97 15.9 22.1 17.36 22.1 18V19.1H9.9V18C9.9 17.36 13 15.9 16 15.9Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_967_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_967_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateHrIcon);
export default __webpack_public_path__ + "static/media/CreateHrIcon.ad5130125ab11b2bb0954a97d5a005bc.svg";
export { ForwardRef as ReactComponent };